/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `Updated`
};

const fr_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `Mis à jour`
};

const de_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `Aktualisiert`
};

const es_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `Actualizado`
};

const it_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiornato`
};

const ar_collection_card_tag_updated24 = /** @type {(inputs: {}) => string} */ () => {
	return `محدث`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_card_tag_updated24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_card_tag_updated24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_card_tag_updated24", locale)
	if (locale === "en") return en_collection_card_tag_updated24(inputs)
	if (locale === "fr") return fr_collection_card_tag_updated24(inputs)
	if (locale === "de") return de_collection_card_tag_updated24(inputs)
	if (locale === "es") return es_collection_card_tag_updated24(inputs)
	if (locale === "it") return it_collection_card_tag_updated24(inputs)
	return ar_collection_card_tag_updated24(inputs)
};
export { collection_card_tag_updated24 as "COLLECTION_CARD_TAG_UPDATED" }